export default () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.91005 8.3753C8.36332 7.82857 8.36332 6.94214 8.91005 6.3954C9.45678 5.84867 10.3432 5.84867 10.89 6.3954L16.49 11.9954C17.0367 12.5421 17.0367 13.4286 16.49 13.9753L10.89 19.5753C10.3432 20.122 9.45678 20.122 8.91005 19.5753C8.36332 19.0286 8.36332 18.1421 8.91005 17.5954L13.5201 12.9854L8.91005 8.3753Z"
      fill="currentColor"
    />
  </svg>
);
